// extracted by mini-css-extract-plugin
export default {"heading":"as-z","corrected":"bs-z","redirectVerbiageContainer":"cs-z","redirectVerbiageText":"ds-z"};